export const toggleInArray = <T>(item: T, array: T[]) => {
  const exist = array.includes(item);

  if (exist) {
    return array.filter((el) => el !== item);
  } else {
    return [...array, item];
  }
};
